import { render, staticRenderFns } from "./PlayerProfileCard.vue?vue&type=template&id=1d3d79f5&scoped=true"
import script from "./PlayerProfileCard.js?vue&type=script&lang=js&external"
export * from "./PlayerProfileCard.js?vue&type=script&lang=js&external"
import style0 from "./PlayerProfileCard.vue?vue&type=style&index=0&id=1d3d79f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d79f5",
  null
  
)

export default component.exports